import { Routes } from '@angular/router';
import {Home} from './pages/home/home';
import {PrivacyPolicy} from './pages/privacy-policy/privacy-policy';
import {Faq} from './pages/faq/faq';

// export const routes: Routes = [
//   { path: '', redirectTo: 'home', pathMatch: 'full' },
//   { path: 'home', component: Home },
//   { path: 'privacy-policy', component: PrivacyPolicy },
//   { path: 'faq', component: Faq }
// ];

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home').then(m => m.Home)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy').then(m => m.PrivacyPolicy)
  },
  {
    path: 'faq',
    loadComponent: () => import('./pages/faq/faq').then(m => m.Faq)
  }
];
